// extracted by mini-css-extract-plugin
export default {"semi-circle":"semi-circle_semi-circle__gnGjU"};